export default "__VITE_ASSET__VdSXrO$o__"